<template>
  <el-dialog
    append-to-body
    width="400px"
    title="设置下单当天配送"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      class="staff-from"
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="120px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
    >
      <el-form-item label="起送金额" prop="amount">
        <el-input
          v-model="form.data.amount"
          clearable
          placeholder="请输入"
          v-money
        >
        </el-input>
      </el-form-item>
      <el-form-item label="最晚下单时间" prop="time">
        <el-time-picker
          v-model="form.data.time"
          clearable
          format="HH:mm"
          value-format="HH:mm"
          placeholder="选择时间"
        >
        </el-time-picker>
      </el-form-item>
      <div class="el-form-item-msg">
        最后修改时间:{{ setDeliveryForm.operation_time }} ({{
          setDeliveryForm.operation_name
        }})
      </div>
    </el-form>

    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import { getStorage } from "@/storage";
export default {
  name: "OrderRiderEdit",
  data() {
    return {
      token: getStorage("token"),
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      setDeliveryForm: {},
      form: {
        loading: false,
        data: {
          amount: "",
          time: "",
        },
        rules: {
          amount: [
            {
              required: true,
              message: "必填",
              trigger: ["change", "blur"],
            },
          ],
          time: [
            {
              required: true,
              message: "请选择",
              trigger: ["change", "blur"],
            },
          ],
        },
      },
    };
  },
  methods: {
    reset(done) {
      this.$emit("reBack");
      this.form.data = {
        amount: "",
        time: "",
      };
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(setDeliveryForm) {
      this.form.data.amount = setDeliveryForm.amount;
      this.form.data.time = setDeliveryForm.time;
      this.setDeliveryForm = setDeliveryForm;
    },
    // 提交
    confirm() {
      console.log(this.form.data);
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let _param = {
            amount: this.form.data.amount,
            time: this.form.data.time,
            status: 1,
          };
          this.form.loading = true;
          this.$http
            .post("/admin/order/setDelivery", _param)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功！");
                this.toggle(false);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
/* .idPhoto .avatar{
    width: 100% !important;
  } */
.idPhoto .avatar-uploader-icon {
  width: 178px !important;
  height: 178px !important;
  line-height: 178px !important;
  border: 1px dashed #d9d9d9;
}
.onBtn-large {
  display: flex;
  justify-content: center;
}
</style>
